import { useState, useCallback } from 'react';
import { MENUS } from '../../libraries/menu.library';
import { useResources } from "@aetonix/hooks";

export default () => {
	const [navigationIndex, setNavigationIndex] = useState(0);
	const [activeTray, setActiveTray] = useState(MENUS.NONE);
	const {dispatch} = useResources();

	const onResetNavigation = useCallback(() => {
		setActiveTray(MENUS.NONE);
	});

	const onClickNavigation = useCallback((index, item) => {
		onResetNavigation();
		setNavigationIndex(index);

		item?.onClick?.();
	}, [onResetNavigation]);

	const setMenu = useCallback(menu => {
		if (menu === activeTray) {
			return onResetNavigation();
		}
		setActiveTray(menu);
		if(menu) dispatch("usermetrics:trigger:track", `navigate to ${menu} tray in group calling`)();
	}, [activeTray, onResetNavigation])

	return {
		navigationIndex,
		menu: activeTray,
		setMenu,
		onClickNavigation,
	}
}
